
var sprite = require("C:/git/annenberg-petspace-petbook/node_modules/svg-sprite-loader/lib/web/global-sprite");
var image = "<symbol viewBox=\"0 0 17.42 19.85\" id=\"play\" ><path d=\"M16.89 10.68a.79.79 0 0 0 0-1.5L1.3.18C.58-.24 0 .1 0 .93v18c0 .82.58 1.16 1.3.75z\"/></symbol>";
module.exports = sprite.add(image, "play");


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/play.svg
// module id = 307
// module chunks = 1